if (!customElements.get('byte-download-button')) {
  class ByteDownloadButton extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      this.boundClick = this.#onClick.bind(this);
      this.link?.addEventListener('click', this.boundClick);
    }

    disconnectedCallback() {
      this.link?.removeEventListener('click', this.boundClick);
    }

    async #onClick(event) {
      if (!this.link || this.hasAttribute('data-loading')) {
        event.preventDefault();
        return;
      }

      event.preventDefault();

      const url = this.link.href;
      const filename = this.link.dataset.filename || '';

      this.setAttribute('data-loading', '');

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`Download failed: ${response.status}`);

        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);

        const anchor = document.createElement('a');
        anchor.href = objectUrl;
        anchor.download = filename;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();

        setTimeout(() => URL.revokeObjectURL(objectUrl), 10000);
      } catch (error) {
        window.open(url, '_blank', 'noopener');
      } finally {
        this.removeAttribute('data-loading');
      }
    }
  }

  customElements.define('byte-download-button', ByteDownloadButton);
}
